<template>
  <div class="row g-3 mb-3">
    <!-- Total Sub-Entities -->
    <div class="col-md-4">
      <div class="card shadow-lg border-0 rounded-lg h-100">
        <div class="card-body">
          <p class="text-muted text-xs mb-1">Total Sub-Entities</p>
          <h4 class="fw-bold mb-0">{{ stats.total }}</h4>
        </div>
      </div>
    </div>

    <!-- Active Sub-Entities -->
    <div class="col-md-4">
      <div class="card shadow-lg border-0 rounded-lg h-100">
        <div class="card-body">
          <p class="text-muted text-xs mb-1">Active Sub-Entities</p>
          <h4 class="fw-bold mb-0 text-success">{{ stats.active }}</h4>
        </div>
      </div>
    </div>

    <!-- Next Meeting -->
    <div class="col-md-4">
      <div class="card shadow-lg border-0 rounded-lg h-100">
        <div class="card-body">
          <p class="text-muted text-xs mb-1">Next Meeting</p>
          <h6 class="fw-bold mb-0">
            {{ stats.next_meeting || 'Not scheduled' }}
          </h6>
        </div>
      </div>
    </div>

  </div>
</template>

<script>import axios from "axios";
import { COUNT_SUB_ENTITIES_URL, get_headers } from "@/utils/constants/constants";

export default {
  name: "CountSubEntities",
  props: {
    entity_profile_id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      is_loading: false,
      stats: {
        total: 0,
        active: 0,
        next_meeting: null
      }
    };
  },
  watch: {
    entity_profile_id: {
      immediate: true,
      handler() {
        this.fetch_stats();
      }
    }
  },
  methods: {
    async fetch_stats() {
      if (!this.entity_profile_id) return;

      this.is_loading = true;
      try {
        const response = await axios.get(COUNT_SUB_ENTITIES_URL, {
          headers: get_headers(),
          params: { entity_profile_id: this.entity_profile_id }
        });

        if (response.data.status === "success") {
          this.stats.total = response.data.sub_entity_count;
          this.stats.active = response.data.active_sub_entity_count || 0; // if not returned
          this.stats.next_meeting = response.data.next_meeting || null;
        }
      } catch (err) {
        this.show_error("Failed to load sub-entity stats", err);
      } finally {
        this.is_loading = false;
      }
    }
  }
};

</script>
